import { useTranslation } from 'react-i18next'
import { SideEditor } from '../../chats/SideEditor'
import { SIDE_SETTINGS_KEY, SIDE_WIDGETS, sideColumnFrom, type SideBlock, type SideBlockId } from '../../chats/sideLayout'
import { useWorkspace } from '../../workspace/WorkspaceProvider'
import { Section } from '../ChatAssistant/compact/kit'
import { C } from '../ChatAssistant/compact/tokens'
import '../../chat/chat.css'

/**
 * Settings → Styling → Chat side column (ADR 0024 §3): the same editor the
 * side column opens with its ✎ button, so the arrangement looks and works the
 * same in both places. Saved with the person's Workspace preferences on the
 * server, so only offered once those are loaded (the server keeps one
 * settings object; saving before reading would replace it).
 */
export function SideColumnSettings() {
  const { t } = useTranslation('settings')
  const ws = useWorkspace()
  if (!ws.enabled || !ws.prefsLoaded) return null
  const blocks = sideColumnFrom(ws.settings[SIDE_SETTINGS_KEY])
  const available = (id: SideBlockId) => ws.enabled || !SIDE_WIDGETS.has(id)
  const save = (next: SideBlock[] | null) => ws.updateSettings({ [SIDE_SETTINGS_KEY]: next ? { blocks: next } : null })

  return (
    <Section title={t('styling.side.title')}>
      {/* .rc-chat carries the chat's colour tokens; the box is the column's own width. */}
      <div
        className="rc-chat"
        style={{ display: 'block', flex: 'none', width: '100%', maxWidth: 380, background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, overflow: 'hidden' }}
      >
        <SideEditor blocks={blocks} available={available} onChange={save} />
      </div>
    </Section>
  )
}
